exports.GlobalURL_FLAG = 0; // ! Set flag to 1 to work locally. 0 to push to GitHub.